/**
 * Tilled Admin API
 *
 * Contact: integrations@tilled.com
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


export interface AdminUpdateDisputeStatusParams { 
    /**
     * The desired dispute outcome
     */
    status: AdminUpdateDisputeStatusParams.StatusEnum;
}
export namespace AdminUpdateDisputeStatusParams {
    export type StatusEnum = 'won' | 'lost';
    export const StatusEnum = {
        WON: 'won' as StatusEnum,
        LOST: 'lost' as StatusEnum
    };
}


